// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"193":"3087b75c","213":"549fa104","239":"857461c6","453":"abff4ba9","553":"e2bcb657","762":"fcbae498"}[chunkId] + ".chunk.js";
};